import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'myabvv-introduction',
    standalone: true,
    templateUrl: './introduction.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntroductionComponent implements OnInit {
  @Input() introduction: string;

  constructor() { }

  ngOnInit() {
  }

}
